import PropTypes from "prop-types";
import React from "react";

export default class WalletDescription extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

        }
    }

    render() {
        return (
            <div className={"mt-2"}>
                {
                    (this.props.payable_categories.length > 0 || this.props.payable_items.length > 0) &&
                    <div>
                        {/*Categorie pagabili*/}
                        {this.props.payable_categories.map((c, i) => {
                            return <div key={i}>
                                - {c.max_payments_num} crediti su {c.initial_max_payments_num} per la categoria <b>{c.nome}</b>
                            </div>
                        })}

                        {/*Items pagabili*/}
                        {this.props.payable_items.map((item, i) => {
                            return <div className={"small"} key={i}>
                               - {item.max_payments_num} crediti su {item.initial_max_payments_num} per l'elemento: <b>{item.nome}</b>
                            </div>
                        })}
                    </div>
                }
            </div>
        )
    }
}

WalletDescription.propTypes = {
    payable_categories: PropTypes.array,
    payable_items: PropTypes.array,
}